/**
 * @module $Name$
 */
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import '@ey-xd/motif-core/src/styles.css';
import config from '../../auth/config';
import * as TimeoutAction from '../../actions/timeoutactions';
import LogoutModal from '@ey/canvascoreservices/LogoutModal';
import {labels} from '../../util/utils';
import Utility from '../../util/utilityfunctions';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import StyledBackground from './StyledBackground';
import SoftwareUpdateModal from '../Common/SoftwareUpdatesModal';

function Main(props) {
	const {children} = props;
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.isLoading);
	const sessionTimer = useSelector((state) => state.sessionTimer);
	const [loadingIndicator, setloadingIndicator] = useState(false);
	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const [timerMessage, setTimerMessage] = useState(labels.sessionTimerMsgLine3);
	const [intervalID, setIntervalID] = useState(null);

	useEffect(() => {
		setloadingIndicator(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (sessionTimer.showPopup) {
			setShowLogoutModal(true);
			calculateRemainingTime();
			let _intervalID = setInterval(calculateRemainingTime, 60000);
			setIntervalID(_intervalID);
		} else if (sessionTimer.startLogout) {
			logoutUser();
		}
	}, [sessionTimer]);

	const calculateRemainingTime = () => {
		setTimerMessage(
			labels.sessionTimerMsgLine3.replace('{0}', () => {
				let startTime = sessionTimer.logoutTimestamp;
				let endTime = startTime + config.logout_time;
				return Math.round((endTime - Date.now()) / 60000);
			})
		);
	};

	const logoutUser = () => {
		setloadingIndicator(true);
		if (intervalID) {
			clearInterval(intervalID);
			setIntervalID(null);
		}
		dispatch(TimeoutAction.logoutUser());
	};

	const handlerOnModalContinueCloseClick = () => {
		setShowLogoutModal(false);
		dispatch(TimeoutAction.resetIdleTimer());
	};

	return (
		<StyledBackground>
			{showLogoutModal && (
				<LogoutModal
					show
					onContinueClick={handlerOnModalContinueCloseClick}
					onLogoutClick={logoutUser}
					onCloseClick={handlerOnModalContinueCloseClick}
					titleHeader={labels.logoutModalTitle}
					logoutMsgLine1={labels.sessionTimerMsgLine1}
					logoutMsgLine2={labels.sessionTimerMsgLine2}
					logoutMsgLine3={timerMessage}
					logoutMsgLine4={labels.sessionTimerMsgLine4}
					continueLabel={Utility.createRichTextElement(labels.modalContinueButton)}
					logoutLabel={labels.modalLogoutButton}
					closeTitle={labels.modalCloseButton}
					modalSize={'small'}
					modalContainerClass="logout-modal"
					modalBodyMsgLine1Class="warning-icon-text"
					modalBodyMsgLine2Class="logout-body-msg-line-2"
					modalBodyMsgLine3Class="logout-body-msg-line-3"
					modalBodyMsgLine4Class="logout-body-msg-line-4"
					modalBodyMsgLine4ContinueClass="continue-text"
					theme={Utility.getMotifTheme()}
				/>
			)}
			<SoftwareUpdateModal />
			{children}
		</StyledBackground>
	);
}

export default withRouter(Main);
